import {
    UPDATING_COMMENTS
} from '../../GlobalStateContainer'


export function updateCheckoutUserComments(comments) {
    return { type: UPDATING_COMMENTS, comments }
}

